import React from 'react';
import { Route } from 'react-router-dom';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
// import routes
import {ROUTES, SERVER_APIS} from './assets/constants/routes';
// import components
import Header from './components/Header';
import SideMenu from './components/SideMenu';
import Footer from './components/Footer';
// import views
import HomePage from './views/Home';
import CreateSessionPage from './views/CreateSession';
import TrackSessionPage from './views/TrackSession';


class App extends React.Component{

  render(){
    return (
      <div css={css`
        width: 100%;
        min-width: 1000px;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: flex-end;
      `}>

        <div css={css`
          flex-grow: 0;
        `}>
          <Header />
        </div>

        <div css={css`
          flex-grow: 1;
        `}>
          <div css={css`
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
          `}>

            <div css={css`
              flex-grow: 0;
            `}>
              <SideMenu />
            </div>

            <div css={css`
              flex-grow: 1;
            `}>

              <div css={css`
                max-width: 980px;
                margin: 0 auto;
              `}>
              
                <Route exact path={ROUTES.HOME}
                  render={
                    (props)=><HomePage {...props}
                      breadcrumbLabel="HOME"
                    />
                  }
                />

                <Route 
                  path={`${ROUTES.DATAPROCESSING}${ROUTES.CREATESESSION}`} 
                  render={
                    (props)=><CreateSessionPage {...props} 
                      breadcrumbLabel="CREATE SESSION"
                      SERVER_APIS={SERVER_APIS} />
                  }
                />

                <Route 
                  path={`${ROUTES.DATAPROCESSING}${ROUTES.TRACKSESSION}`} 
                  render={
                    (props)=><TrackSessionPage {...props} 
                      breadcrumbLabel="TRACK SESSION"
                      SERVER_APIS={SERVER_APIS} />
                  }
                />

              </div>
            </div>
          </div>
        </div>
        
        <div css={css`
          flex-grow: 0;
        `}>
          <Footer />
        </div>
      </div>
    )
  }
}

export default App;